import { render } from "./TheCRUDFrameModal.vue?vue&type=template&id=3b95027d"
import script from "./TheCRUDFrameModal.vue?vue&type=script&lang=js"
export * from "./TheCRUDFrameModal.vue?vue&type=script&lang=js"

import "./TheCRUDFrameModal.vue?vue&type=style&index=0&id=3b95027d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__